export interface ExternalRatingFormat {
  rating: number;
  name: string;
}

export const externalRatingsGrouper = (
  ratings: string[],
  names: string[],
): ExternalRatingFormat[] => {
  return ratings.map((item, index) => {
    return {
      rating: Number(item),
      name: names[index],
    };
  });
};

export const ratingsArrayCreator = (rating: number) => {
  const flooredRating = Math.floor(rating);
  const halfRating = rating - flooredRating >= 0.5 ? 0.5 : 0;

  const circleArray = new Array(5)
    .fill(1, 0, flooredRating)
    .fill(halfRating, flooredRating, flooredRating + 1)
    .fill(0, flooredRating + 1, 5);

  return circleArray;
};
